// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#navbar {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  justify-items: center;
  gap: 1em;
}
.parentContainer {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  width: 200px;
  cursor: pointer;
  z-index: 9999;
  -webkit-tap-highlight-color: transparent;
}

.parentItem {
  font-size: 1.5rem;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 0.5rem;
}

.itemsContainer {
  justify-content: center;
  flex-direction: column;
  align-items: start;
  align-items: center;
  justify-content: space-evenly;
  opacity: 0;
  transform: rotateX(-180deg);
  bottom:0;
  transition: transform 200ms ease-in 0s;
  position: relative;
}

.dummy-item-container {
  width: 200px;
  height: 2vh;
  display: flex;
  justify-content: center;
  align-items: stretch;
}

.dummy-item {
  width: 30px;
  height: 2vh;
  border-left: 2px solid #090a0a38;
  border-right: 2px solid #090a0a38;
  border-radius: 2px;
}

.item:not(.dummy-item) {
  font-size: 0.95rem;
  width: 200px;
  height: 4vh;
  border: 2px solid #090a0a38;
  padding-left: 1em;
  display: flex;
  align-items: center;
  font-weight: 200;
  color: #090a0ac2;
  cursor: pointer;
  margin-top: 0.5em;
  border-radius: 5px;
  background-color: #ffffff;
  transform: skewX(10deg);
  font-weight: 200;
}

.itemsContainer > :nth-child(2) {
  margin-top: 0;
}

.itemsContainer.visible {
  display: flex;
  opacity: 1;
  transform: rotateX(0);
}

.change-border-bottom {
  animation: animated-border 200ms ease-in-out 300ms forwards;
}

@keyframes animated-border {
  0% {
    border-bottom: 0px solid #090a0a38;
  }
  25% {
    border-bottom: 2px solid #090a0a38;
  }
  50% {
    border-bottom: 3px solid #090a0a38;
  }
  100% {
    border-bottom: 5px solid #090a0a38;
  }
}

.item.animated {
  transform: skewX(-10deg);
  color: #000000;
  background-color: rgba(0, 0, 0, 0.1);
  font-weight: 800;
}`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,2DAA2D;EAC3D,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,4DAA4D;EAC5D,YAAY;EACZ,eAAe;EACf,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,UAAU;EACV,2BAA2B;EAC3B,QAAQ;EACR,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,oCAAoC;EACpC,gBAAgB;AAClB","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n#navbar {\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  justify-items: center;\n  gap: 1em;\n}\n.parentContainer {\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n  width: 200px;\n  cursor: pointer;\n  z-index: 9999;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.parentItem {\n  font-size: 1.5rem;\n  font-weight: bold;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-top: 0.5rem;\n}\n\n.itemsContainer {\n  justify-content: center;\n  flex-direction: column;\n  align-items: start;\n  align-items: center;\n  justify-content: space-evenly;\n  opacity: 0;\n  transform: rotateX(-180deg);\n  bottom:0;\n  transition: transform 200ms ease-in 0s;\n  position: relative;\n}\n\n.dummy-item-container {\n  width: 200px;\n  height: 2vh;\n  display: flex;\n  justify-content: center;\n  align-items: stretch;\n}\n\n.dummy-item {\n  width: 30px;\n  height: 2vh;\n  border-left: 2px solid #090a0a38;\n  border-right: 2px solid #090a0a38;\n  border-radius: 2px;\n}\n\n.item:not(.dummy-item) {\n  font-size: 0.95rem;\n  width: 200px;\n  height: 4vh;\n  border: 2px solid #090a0a38;\n  padding-left: 1em;\n  display: flex;\n  align-items: center;\n  font-weight: 200;\n  color: #090a0ac2;\n  cursor: pointer;\n  margin-top: 0.5em;\n  border-radius: 5px;\n  background-color: #ffffff;\n  transform: skewX(10deg);\n  font-weight: 200;\n}\n\n.itemsContainer > :nth-child(2) {\n  margin-top: 0;\n}\n\n.itemsContainer.visible {\n  display: flex;\n  opacity: 1;\n  transform: rotateX(0);\n}\n\n.change-border-bottom {\n  animation: animated-border 200ms ease-in-out 300ms forwards;\n}\n\n@keyframes animated-border {\n  0% {\n    border-bottom: 0px solid #090a0a38;\n  }\n  25% {\n    border-bottom: 2px solid #090a0a38;\n  }\n  50% {\n    border-bottom: 3px solid #090a0a38;\n  }\n  100% {\n    border-bottom: 5px solid #090a0a38;\n  }\n}\n\n.item.animated {\n  transform: skewX(-10deg);\n  color: #000000;\n  background-color: rgba(0, 0, 0, 0.1);\n  font-weight: 800;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
